import '.er{font-size:1.125rem;}.ssr-plugin'
import '.ee{line-height:1.75rem;}.ssr-plugin'
import '.bw{text-decoration:none;}.ssr-plugin'
import '.h9{color:var(--brand-primary);}.ssr-plugin'
import { pages } from '@app/util/links'
import { useTranslations } from '@i18n/useLanguage'
import { styled } from 'inlines'

export const TermsAndConditions = () => {
  const translations = useTranslations().app.auth
  return (
    <p className="er ee"
    >
      {translations.privacySubtitle}{' '}
      <a className="bw h9"
        href={pages.legal}
        target="_blank"
        rel="noopener noreferrer"
      >
        {translations.privacyStatementLink}
      </a>{' '}
      {translations.privacySubtitleAnd}{' '}
      <a className="bw h9"
        href={pages.legal}
        target="_blank"
        rel="noopener noreferrer"
      >
        {translations.termsAndConditionsLink}
      </a>
    </p>
  )
}
